import { ConnectedWallet } from '@privy-io/react-auth'
import { providers } from 'ethers'

export async function getSigner(wallet: ConnectedWallet | undefined, chainId: number) {
    if (!wallet) {
        return undefined
    }

    await wallet.switchChain(chainId)
    const privyProvider = await wallet.getEthereumProvider()
    const provider = new providers.Web3Provider(privyProvider)
    const signer = provider?.getSigner()

    if (!signer) {
        throw new Error('[WalletReady]: Failed to get signer')
    }

    return signer
}
